/**
 * @deprecated This configuration has been moved to `@vts/client-config` library.
 * Please use `import { routes } from '@vts/client-config/lib/routes/visitorManagementRoutes'` instead.
 * This file will be removed in a future version.
 * @see {@link https://github.com/VTS-com/lane-next/tree/main/libs/client-config/src/lib/routes/visitorManagementRoutes.ts}
 */
export const routes = {
  registrationForm: 'visitor-management/forms',
  visitorConfiguration: 'visitor-management/configuration',
  visitorLog: 'visitor-management/log',
  visitorPassDetails: 'visitor-management/visitorpass/:visitorPassId',
  recurrenceDetails: 'visitor-management/recurrencedetail/:recurrenceId',
  visitorWatchlist: 'visitor-management/watchlist',
  visitorWatchlistForm: 'visitor-management/watchlist/add',
  visitorWatchlistDetails: 'visitor-management/watchlist/details/:watchlistId',
  visitorCustomFieldCreate: 'visitor-management/configuration/custom-fields/new',
  visitorCustomFieldDetail: 'visitor-management/configuration/custom-fields/:customFieldId',
};
